import axios from 'axios';
import * as _ from 'lodash';
import store from '@/store/store';
import router from '@/router/router';
import { UserPermissions } from '@/utils/userInfo';
import { NotificationsTypes } from '@/constants/notificationsTypes';
import * as ErrorExceptions from '@/constants/error-exceptions';
import { LOGIN, ERRORS } from '@/router/names';

let subscribers = [];
let tokenIsRefreshing = false;

export const HTTP = axios.create({
    baseURL: process.env.API_URL,
});

HTTP.interceptors.request.use(
    config => {
        config.url = config.url.replace('slug', router.currentRoute.params.school);
        const { activityType, search } = router.currentRoute.query;

        const userInfo = UserPermissions.getUserInfoFromLocalStorage();
        store.dispatch('showProgress', true);

        config.withCredentials = true;

        config.headers = {
            ...config.headers,
            'Content-Type': 'application/json',
            'AuthenticationHeader': 'PARENT'
        };

        userInfo
            ? config.headers = { ...config.headers, 'Authorization': userInfo.jwtToken }
            : config.headers;

//this need for correct work copy link from schools app
        !userInfo && activityType && localStorage.setItem('activity-info', JSON.stringify({ activityType, search }));

        return config;
    },

    error => Promise.reject(error)
);

HTTP.interceptors.response.use(
    response => {
        store.dispatch('showProgress', false);
        return response;
    },

    error => {
        const { status, data, config } = error.response;
        const userInfo = UserPermissions.getUserInfoFromLocalStorage();

        store.dispatch('showProgress', false);

        if (userInfo) {
            switch (status) {
                case 400:
                    data === ErrorExceptions.SCHOOL_NOT_FOUND
                        ? router.push({ name: 'ERRORS', params: router.currentRoute.params, query: { exception: data } })
                        : data.showMessageToUser && store.dispatch('createNotification', { message: data.message, type: NotificationsTypes.ERROR });
                    break;

                case  401:
                    if (((window.navigator.userAgent.indexOf('MSIE') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) && !config.url.indexOf('refresh') >=0) || !config.url.includes('refresh')) {
                        return refreshTokenCallback(config)
                    }
                    else {
                        throw error.response;
                    }

                case 403:
                    data === ErrorExceptions.EMAIL_VERIFICATION_TOKEN_DOES_NOT_EXIST
                        ? router.push({ name: 'LOGIN', params: router.currentRoute.params })
                        : router.push({ name: 'ERRORS', params: router.currentRoute.params, query: { exception: data } });
                    break;

                default:
                    store.dispatch('createNotification', {
                        message: 'Oops! Something went wrong',
                        type: NotificationsTypes.ERROR
                    });
            }

            throw error.response;
        }
        else {
            status === 400
                ? (data === ErrorExceptions.SCHOOL_NOT_FOUND) && router.push({ name: 'ERRORS', params: router.currentRoute.params, query: { exception: data } })
                : router.push({ name: 'LOGIN', params: router.currentRoute.params });

            throw error.response;
        }
    }
);

async function refreshTokenCallback(config) {
    if (!tokenIsRefreshing) {
        tokenIsRefreshing = true;
        try {
            // refresh expired token
            await store.dispatch('refreshToken');

            const refreshedInfo = UserPermissions.getUserInfoFromLocalStorage();

            // retry all failed requests
            executeSubscribersRequests(refreshedInfo.jwtToken);

            // retry first failed request which isn't on subscribers array
            const newRequest = {
                ...config,
                baseURL: ''
            };
            newRequest.headers.Authorization = refreshedInfo.jwtToken;
            return axios.request(newRequest);

        } catch (error) {
            // if refreshToken request failed
            router.push({ name: 'LOGIN', params: router.currentRoute.params });
            throw error.response;
        } finally {
            tokenIsRefreshing = false;
        }
    } else {
        // push failed request to the subscribers array
        return new Promise(resolve => {
            pushSubscriber(token => {
                config.headers.Authorization = token;
                resolve(axios(config));
            });
        });
    }
}

function executeSubscribersRequests(token) {
    _.forEach(subscribers, callback => callback(token));
    subscribers = [];
}

function pushSubscriber(subscriber) {
    subscribers.push(subscriber);
}


// WEBPACK FOOTER //
// ./src/http/http-client.js